import { render, staticRenderFns } from "./OutboundCampaigns.vue?vue&type=template&id=f3a66216&scoped=true"
import script from "./OutboundCampaigns.vue?vue&type=script&lang=js"
export * from "./OutboundCampaigns.vue?vue&type=script&lang=js"
import style0 from "./OutboundCampaigns.vue?vue&type=style&index=0&id=f3a66216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a66216",
  null
  
)

export default component.exports